import { useNetwork } from '@/presentation/context/network';
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';
import { useAccount, useBalance, useEnsAvatar, useEnsName } from 'wagmi';
import OverlayMenu, { Page } from './OverlayMenu';
import ellipsis from '@/presentation/utils/ellipsis';
import ConnectButton from '@/presentation/components/widgets/ConnectButton';
import CurrencySelect from '@/presentation/components/widgets/CurrencySelect';
import ThemeToggle from '@/presentation/components/widgets/ThemeToggle';
import NetworkSelect from '@/presentation/components/widgets/NetworkSelect';
import { BountyButton } from '@/presentation/components/widgets/BountyButton';

const OverlayMenuContainer = () => {
  const { slug, chain } = useNetwork();
  const { isConnected, address } = useAccount();
  const { data: ens } = useEnsName({ address });
  const { data: avatar } = useEnsAvatar({ name: ens });
  const { data: balance } = useBalance({ address });

  const pathname = usePathname();

  const username = ens || ellipsis(address);

  const activePage = useMemo(() => {
    const path = pathname.split('/');

    if (path.includes('profile')) {
      return 'profile';
    }

    return path.pop() || 'profile';
  }, [pathname]) as Page;

  return (
    <OverlayMenu
      chainSlug={slug}
      chain={chain}
      isConnected={isConnected}
      avatar={avatar}
      address={address}
      username={username}
      balance={Number(balance?.formatted)}
      activePage={activePage}
      connectButton={<ConnectButton className="w-full" />}
      currencySelect={<CurrencySelect />}
      networkSelect={<NetworkSelect />}
      themeToggle={<ThemeToggle />}
      bountyButton={<BountyButton className="mb-4 h-12" />}
    />
  );
};

export default OverlayMenuContainer;
